(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();
        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yves-ai-coach"] && !Shopify.designMode) return;
  try {
    
  class YvesCoach {
    constructor(root) {
      this.root = root;
      this.endpoint = root.dataset.endpoint || '/api/yves-chat';
      this.chatEl = root.querySelector('[data-yves-chat]');
      this.quickRepliesEl = root.querySelector('[data-yves-quick-replies]');
      this.passportForm = root.querySelector('[data-yves-passport-form]');
      this.nameInput = root.querySelector('[data-yves-name]');
      this.emailInput = root.querySelector('[data-yves-email]');
      this.collectionInputs = root.querySelectorAll('[data-yves-collection]');
      this.flowInputs = root.querySelectorAll('[data-yves-flow]');
      this.photoGroup = root.querySelector('[data-yves-photo-group]');
      this.dropzone = root.querySelector('[data-yves-dropzone]');
      this.preview = root.querySelector('[data-yves-preview]');
      this.uploadStatus = root.querySelector('[data-yves-upload-status]');
      this.formError = root.querySelector('[data-yves-form-error]');
      this.analyseBtn = root.querySelector('[data-yves-analyse]');
      this.form = root.querySelector('[data-yves-composer]');
      this.input = root.querySelector('[data-yves-input]');
      this.fileInput = root.querySelector('[data-yves-file]');
      this.sendBtn = root.querySelector('[data-yves-send]');
      this.attachmentBtn = root.querySelector('[data-yves-attachment]');
      this.avatarBtn = root.querySelector('[data-yves-avatar]');
      this.video = root.querySelector('.yves-coach__video');
      this.history = [];
      this.pendingImages = [];
      this.pendingImagePreview = '';
      this.lookbooks = [
        {
          title: 'Women · Spring–Summer 2026',
          url: 'https://capsule.style/collections/women-ss26',
          image: 'https://capsule.style/cdn/shop/files/Modern-Nomad-10.png?v=1776339995&width=980',
          action: 'Shop Spring–Summer 2026 →',
          matches: ['https://capsule.style/collections/women-ss26']
        },
        {
          title: 'Men · Spring–Summer 2026',
          url: 'https://capsule.style/collections/men-ss26',
          image: 'https://capsule.style/cdn/shop/files/Strategic-Creative-8.png?v=1776438280&width=980',
          action: 'Shop Spring–Summer 2026 →',
          matches: ['https://capsule.style/collections/men-ss26']
        },
        {
          title: 'The Leader',
          url: 'https://capsule.style/pages/the-leader-lookbook',
          image: 'https://capsule.style/cdn/shop/files/LEADER_13.png?v=1758985275&width=1000',
          matches: ['https://capsule.style/pages/the-leader-lookbook', 'https://capsule.style/collections/⭐️-the-leader']
        },
        {
          title: 'The Wanderer',
          url: 'https://capsule.style/pages/the-wanderer-lookbook',
          image: 'https://capsule.style/cdn/shop/files/WANDERER.png?v=1758951454&width=1000',
          matches: ['https://capsule.style/pages/the-wanderer-lookbook', 'https://capsule.style/collections/🌿-the-wanderer']
        },
        {
          title: 'The Artist',
          url: 'https://capsule.style/pages/the-artist-lookbook',
          image: 'https://capsule.style/cdn/shop/files/ARTIST.png?v=1758884004&width=1000',
          matches: ['https://capsule.style/pages/the-artist-lookbook', 'https://capsule.style/collections/the-artist']
        },
        {
          title: 'The Muse',
          url: 'https://capsule.style/pages/the-muse-lookbook',
          image: 'https://capsule.style/cdn/shop/files/MUSE_7_3afa8ab8-8bb4-4411-8170-45703da27610.png?v=1759002110&width=1000',
          matches: ['https://capsule.style/pages/the-muse-lookbook', 'https://capsule.style/collections/the-muse']
        },
        {
          title: 'The Dreamer',
          url: 'https://capsule.style/pages/the-dreamer-lookbook',
          image: 'https://capsule.style/cdn/shop/files/DREAMER_1.png?v=1758828335&width=1000',
          matches: ['https://capsule.style/pages/the-dreamer-lookbook', 'https://capsule.style/collections/🌙-the-dreamer']
        },
        {
          title: 'The Modernist',
          url: 'https://capsule.style/pages/the-modernist-lookbook',
          image: 'https://capsule.style/cdn/shop/files/MODERNIST_1_0053380c-e1dc-4b72-bb12-bc19d1e09d0f.png?v=1758885215&width=1000',
          matches: ['https://capsule.style/pages/the-modernist-lookbook', 'https://capsule.style/collections/the-modernist']
        },
        {
          title: 'The Explorer',
          url: 'https://capsule.style/pages/the-explorer-lookbook',
          image: 'https://capsule.style/cdn/shop/files/EXPLORER_6_07a19c7d-d097-47bf-a3ff-c024becad85b.png?v=1758881175&width=1000',
          matches: ['https://capsule.style/pages/the-explorer-lookbook', 'https://capsule.style/collections/the-explorer']
        },
        {
          title: 'The Maker',
          url: 'https://capsule.style/pages/the-maker-lookbook',
          image: 'https://capsule.style/cdn/shop/files/MAKER_1.png?v=1758883757&width=1000',
          matches: ['https://capsule.style/pages/the-maker-lookbook', 'https://capsule.style/collections/💻-the-engineer']
        }
      ];
      this.sessionId = this.getSessionId();
      this.started = false;
      this.maxUserMessages = 100;
      this.maxMessageChars = 1800;
      this.maxImageBase64Chars = 2000000;
      this.hiddenStarterMessage = "I'm ready, let's begin.";
      this.sessionLimitReply = 'That is the end of this free digital passport session. You can book the next stage with Capsule for an in-person wardrobe audit and capsule build.';
      this.init();
    }

    getSessionId() {
      const storageKey = 'capsule-yves-session-id';
      try {
        const existing = window.localStorage.getItem(storageKey);
        if (existing) return existing;
        const sessionId = this.createSessionId();
        window.localStorage.setItem(storageKey, sessionId);
        return sessionId;
      } catch (error) {
        return this.createSessionId();
      }
    }

    createSessionId() {
      if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
      if (window.crypto && window.crypto.getRandomValues) {
        const bytes = new Uint8Array(16);
        window.crypto.getRandomValues(bytes);
        return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
      }
      return `session-${Date.now()}`;
    }

    init() {
      this.passportForm.addEventListener('submit', (event) => {
        event.preventDefault();
        this.submitPassport();
      });

      this.flowInputs.forEach((input) => {
        input.addEventListener('change', () => this.updateFlow());
      });
      this.updateFlow();

      this.dropzone.addEventListener('click', () => this.fileInput.click());
      ['dragenter', 'dragover'].forEach((eventName) => {
        this.dropzone.addEventListener(eventName, (event) => {
          event.preventDefault();
          this.dropzone.classList.add('is-dragging');
        });
      });
      ['dragleave', 'drop'].forEach((eventName) => {
        this.dropzone.addEventListener(eventName, (event) => {
          event.preventDefault();
          this.dropzone.classList.remove('is-dragging');
        });
      });
      this.dropzone.addEventListener('drop', (event) => {
        const file = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0];
        this.handlePhotoFile(file);
      });

      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.submitUserMessage();
      });

      this.input.addEventListener('input', () => {
        this.input.style.height = 'auto';
        this.input.style.height = `${Math.min(this.input.scrollHeight, 150)}px`;
      });

      this.input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' && !event.shiftKey) {
          event.preventDefault();
          this.submitUserMessage();
        }
      });

      this.attachmentBtn.addEventListener('click', () => {
        this.fileInput.click();
      });

      this.fileInput.addEventListener('change', () => {
        const file = this.fileInput.files && this.fileInput.files[0];
        this.fileInput.value = '';
        this.handlePhotoFile(file);
      });

      if (this.video) {
        this.video.play().then(() => {
          this.avatarBtn.classList.add('is-playing');
        }).catch(() => {
          this.avatarBtn.classList.add('is-paused');
        });
      }

      this.avatarBtn.addEventListener('click', () => {
        if (!this.video) return;
        if (this.video.paused) {
          this.video.play();
          this.avatarBtn.classList.add('is-playing');
          this.avatarBtn.classList.remove('is-paused');
        } else {
          this.video.pause();
          this.avatarBtn.classList.remove('is-playing');
          this.avatarBtn.classList.add('is-paused');
        }
      });
    }

    selectedFlow() {
      const selected = Array.from(this.flowInputs).find((input) => input.checked);
      return selected ? selected.value : 'quick';
    }

    updateFlow() {
      const isQuick = this.selectedFlow() === 'quick';
      this.photoGroup.hidden = false;
      this.analyseBtn.textContent = isQuick ? this.analyseBtn.dataset.quickLabel : this.analyseBtn.dataset.fullLabel;
      this.formError.textContent = '';
    }

    addBubble(text, who, extraClass, styleDimensions) {
      const bubble = document.createElement('div');
      bubble.className = `yves-coach__msg yves-coach__msg--${who}${extraClass ? ` ${extraClass}` : ''}`;
      if (who === 'yves') {
        bubble.innerHTML = this.formatReply(text);
        this.appendStyleDimensions(bubble, styleDimensions);
        this.appendLookbookCards(bubble, text, styleDimensions);
      } else {
        bubble.textContent = text;
      }
      this.chatEl.appendChild(bubble);
      this.scrollToLatest();
      return bubble;
    }

    appendStyleDimensions(bubble, dimensions) {
      if (!Array.isArray(dimensions) || !dimensions.length) return;

      const panel = document.createElement('section');
      panel.className = 'yves-coach__dimensions';
      panel.setAttribute('aria-label', 'Your style dimensions');
      const title = document.createElement('span');
      title.className = 'yves-coach__dimensions-title';
      title.textContent = 'Your style dimensions';
      panel.appendChild(title);

      dimensions.slice(0, 4).forEach((dimension) => {
        const score = Math.max(0, Math.min(100, Math.round(Number(dimension.score))));
        if (!Number.isFinite(score)) return;
        const row = document.createElement('div');
        row.className = 'yves-coach__dimension';
        row.setAttribute('role', 'img');
        row.setAttribute('aria-label', `${dimension.name}: ${score} out of 100, from ${dimension.left} to ${dimension.right}`);

        const heading = document.createElement('div');
        heading.className = 'yves-coach__dimension-heading';
        const name = document.createElement('span');
        name.textContent = String(dimension.name || '').slice(0, 30);
        const scoreLabel = document.createElement('span');
        scoreLabel.className = 'yves-coach__dimension-score';
        scoreLabel.textContent = `${score}/100`;
        heading.append(name, scoreLabel);

        const track = document.createElement('div');
        track.className = 'yves-coach__dimension-track';
        track.style.setProperty('--dimension-score', `${score}%`);
        const fill = document.createElement('div');
        fill.className = 'yves-coach__dimension-fill';
        const dot = document.createElement('div');
        dot.className = 'yves-coach__dimension-dot';
        track.append(fill, dot);

        const labels = document.createElement('div');
        labels.className = 'yves-coach__dimension-labels';
        const left = document.createElement('span');
        left.textContent = String(dimension.left || '').slice(0, 30);
        const right = document.createElement('span');
        right.textContent = String(dimension.right || '').slice(0, 30);
        labels.append(left, right);
        row.append(heading, track, labels);
        panel.appendChild(row);
      });
      bubble.appendChild(panel);
    }

    appendLookbookCards(bubble, text, styleDimensions) {
      const reply = String(text || '');
      let matched = this.lookbooks.filter((lookbook) => (
        lookbook.matches.some((url) => reply.includes(url))
      )).slice(0, 3);
      if (Array.isArray(styleDimensions) && styleDimensions.length) {
        const selectedCollection = Array.from(this.collectionInputs).find((input) => input.checked);
        const seasonalUrl = selectedCollection && selectedCollection.value === "men's"
          ? 'https://capsule.style/collections/men-ss26'
          : 'https://capsule.style/collections/women-ss26';
        const seasonalCard = this.lookbooks.find((lookbook) => lookbook.url === seasonalUrl);
        if (seasonalCard) {
          matched = [seasonalCard, ...matched.filter((lookbook) => lookbook.url !== seasonalUrl)].slice(0, 3);
        }
      }
      if (!matched.length) return;

      const grid = document.createElement('div');
      grid.className = 'yves-coach__lookbook-grid';
      grid.setAttribute('aria-label', 'Recommended Capsule collections');
      matched.forEach((lookbook) => {
        const card = document.createElement('a');
        card.className = 'yves-coach__lookbook-card';
        card.href = lookbook.url;
        card.target = '_blank';
        card.rel = 'noopener noreferrer';

        const image = document.createElement('img');
        image.src = lookbook.image;
        image.alt = `${lookbook.title} preview`;
        image.loading = 'lazy';
        image.width = 1000;
        image.height = 1000;

        const copy = document.createElement('span');
        copy.className = 'yves-coach__lookbook-card-copy';
        const title = document.createElement('span');
        title.className = 'yves-coach__lookbook-card-title';
        title.textContent = lookbook.title;
        const action = document.createElement('span');
        action.className = 'yves-coach__lookbook-card-action';
        action.textContent = lookbook.action || 'View the lookbook →';
        copy.append(title, action);
        card.append(image, copy);
        grid.appendChild(card);
      });
      bubble.appendChild(grid);
    }

    addPhotoBubble(dataUrl, caption) {
      const bubble = document.createElement('div');
      bubble.className = 'yves-coach__msg yves-coach__msg--user';
      const image = document.createElement('img');
      image.className = 'yves-coach__chat-photo';
      image.src = dataUrl;
      image.alt = 'Uploaded full-body photo';
      const label = document.createElement('span');
      label.className = 'yves-coach__chat-photo-caption';
      label.textContent = caption;
      bubble.append(image, label);
      this.chatEl.appendChild(bubble);
      this.scrollToLatest();
    }

    formatReply(text) {
      let escaped = String(text || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');

      const links = [];
      const storeLink = (html) => {
        const token = `__YVES_LINK_${links.length}__`;
        links.push({ token, html });
        return token;
      };

      escaped = escaped
        .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
        .replace(/\*\*/g, '')
        .replace(/\[([^\]]+)\]\((https:\/\/[^)\s]+)\)/g, (match, label, url) => (
          storeLink(`<a href="${url}" target="_blank" rel="noopener noreferrer">${label}</a>`)
        ))
        .replace(/(https:\/\/[^\s<]+)/g, (url) => {
          const cleanUrl = url.replace(/[),.]+$/, '');
          const trailing = url.slice(cleanUrl.length);
          return `${storeLink(`<a href="${cleanUrl}" target="_blank" rel="noopener noreferrer">${cleanUrl}</a>`)}${trailing}`;
        });

      links.forEach((link) => {
        escaped = escaped.replace(link.token, link.html);
      });

      return escaped;
    }

    clearQuickReplies() {
      this.quickRepliesEl.innerHTML = '';
    }

    setQuickReplies(replies) {
      this.clearQuickReplies();
      (Array.isArray(replies) ? replies : []).slice(0, 5).forEach((reply) => {
        const label = typeof reply === 'string' ? reply : reply.label;
        const value = typeof reply === 'string' ? reply : reply.value;
        if (!label || !value) return;
        const button = document.createElement('button');
        button.className = 'yves-coach__pill';
        button.type = 'button';
        button.textContent = label;
        button.addEventListener('click', () => {
          this.input.value = value;
          this.submitUserMessage();
        });
        this.quickRepliesEl.appendChild(button);
      });
    }

    getQuickReplies(text) {
      const replies = [];
      const lowerText = String(text || '').toLowerCase();
      if (lowerText.includes('suppressed style') && (lowerText.includes('15-minute') || lowerText.includes('continue'))) {
        replies.push({ label: 'Start the full 15-minute chat', value: 'Start the full 15-minute chat' });
      }

      return replies;
    }

    userMessageCount() {
      return this.history.filter((message) => (
        message.role === 'user' && (
          typeof message.content !== 'string' || message.content !== this.hiddenStarterMessage
        )
      )).length;
    }

    readFileAsDataUrl(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
      });
    }

    async handlePhotoFile(file) {
      if (!file) return;

      if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) {
        this.formError.textContent = 'Please upload a JPEG, PNG, or WebP photo.';
        this.uploadStatus.textContent = '';
        return;
      }

      try {
        const dataUrl = await this.readFileAsDataUrl(file);
        const base64 = String(dataUrl).split(',')[1] || '';
        if (base64.length > this.maxImageBase64Chars) {
          this.formError.textContent = 'That photo is a little too large. Please try a smaller image.';
          this.uploadStatus.textContent = '';
          return;
        }

        this.pendingImages = [{
          type: 'image',
          source: {
            type: 'base64',
            media_type: file.type,
            data: base64
          }
        }];
        this.pendingImagePreview = dataUrl;
        this.formError.textContent = '';
        this.preview.src = dataUrl;
        this.preview.alt = 'Selected full-body photo';
        this.dropzone.classList.add('has-photo');
        this.uploadStatus.textContent = `✓ Photo ready: ${file.name}`;
      } catch (error) {
        this.formError.textContent = 'I could not read that photo. Please try another one.';
        this.uploadStatus.textContent = '';
      }
    }

    submitPassport() {
      const name = this.nameInput.value.trim();
      const email = this.emailInput.value.trim();
      const selectedCollection = Array.from(this.collectionInputs).find((input) => input.checked);
      const flow = this.selectedFlow();
      if (!name || !email || !this.emailInput.validity.valid || !selectedCollection) {
        this.formError.textContent = 'Add your first name, a valid email address, and your collection preference to continue.';
        return;
      }

      if (this.pendingImages.length !== 1) {
        this.formError.textContent = 'Add one full-body photo to continue.';
        return;
      }

      if (flow === 'full') {
        const requestText = `[FULL_STYLE_CHAT]\nFirst name: ${name}\nCollection preference: ${selectedCollection.value}\nEmail: ${email}\nUse this full-body photo as the visual starting point, then begin my full 15-minute style analysis. Keep the complete coaching conversation in chat and ask one question at a time.`;
        this.history = [{ role: 'user', content: [...this.pendingImages, { type: 'text', text: requestText }] }];
        this.addPhotoBubble(this.pendingImagePreview, `${name} · ${selectedCollection.value === "women's" ? "Women's" : "Men's"} collections · Photo uploaded ✓`);
        this.pendingImages = [];
        this.pendingImagePreview = '';
        this.started = true;
        this.passportForm.hidden = true;
        this.form.hidden = false;
        this.callYves();
        return;
      }

      const requestText = `[PHOTO_FIRST_PASSPORT]\nFirst name: ${name}\nCollection preference: ${selectedCollection.value}\nEmail: ${email}\nAnalyse this single full-body photo now and create my draft Style Passport in one response. The email address has already been collected.`;
      this.history = [{ role: 'user', content: [...this.pendingImages, { type: 'text', text: requestText }] }];
      this.addPhotoBubble(this.pendingImagePreview, `${name} · ${selectedCollection.value === "women's" ? "Women's" : "Men's"} collections · Photo uploaded ✓`);
      this.pendingImages = [];
      this.pendingImagePreview = '';
      this.started = true;
      this.passportForm.hidden = true;
      this.form.hidden = false;
      this.callYves();
    }

    endSession(message) {
      if (message !== '') {
        this.addBubble(message || this.sessionLimitReply, 'yves');
      }
      this.input.disabled = true;
      this.sendBtn.disabled = true;
      this.attachmentBtn.disabled = true;
    }

    startConversation(affirmation) {
      if (this.started) return;
      this.started = true;
      this.addBubble("Perfect, let's start. This session will take about 15 min.", 'yves');
      this.history = [
        { role: 'assistant', content: "Hi, I'm Yves, Capsule's styling coach. Are you interested in a personal styling session?" },
        { role: 'user', content: affirmation || 'Yes' },
        { role: 'assistant', content: "Perfect, let's start. This session will take about 15 min." },
        { role: 'user', content: this.hiddenStarterMessage }
      ];
      this.callYves();
    }

    submitUserMessage() {
      const text = this.input.value.trim();
      if (!text && this.pendingImages.length === 0) return;
      this.clearQuickReplies();

      if (text.length > this.maxMessageChars) {
        this.addBubble('Please keep each message to about 300 words so Yves can stay focused.', 'yves');
        return;
      }

      if (this.userMessageCount() >= this.maxUserMessages) {
        this.endSession();
        return;
      }

      this.addBubble(text || 'Photo uploaded', 'user');
      this.input.value = '';
      this.input.style.height = '48px';
      if (!this.started && text.toLowerCase() === 'yes' && this.pendingImages.length === 0) {
        this.startConversation(text);
        return;
      }
      if (this.pendingImages.length) {
        const content = [
          ...this.pendingImages,
          ...(text ? [{ type: 'text', text }] : [])
        ];
        this.history.push({ role: 'user', content });
        this.pendingImages = [];
      } else {
        this.history.push({ role: 'user', content: text });
      }
      this.callYves();
    }

    async callYves() {
      const typingBubble = this.addBubble('Yves is typing...', 'yves', 'yves-coach__msg--typing');
      this.sendBtn.disabled = true;
      this.analyseBtn.disabled = true;

      try {
        const response = await fetch(this.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ sessionId: this.sessionId, messages: this.history })
        });

        if (!response.ok) {
          throw new Error(`Yves endpoint returned ${response.status}`);
        }

        const data = await response.json();
        const reply = data.reply || 'Sorry, I hit a snag. Could you try again?';
        typingBubble.remove();
        this.addBubble(reply, 'yves', '', data.styleDimensions);
        const quickReplies = Array.isArray(data.quickReplies) && data.quickReplies.length
          ? data.quickReplies
          : this.getQuickReplies(reply);
        this.setQuickReplies(quickReplies);
        this.history.push({ role: 'assistant', content: reply });
        if (data.limitReached) {
          this.endSession('');
        }
      } catch (error) {
        typingBubble.remove();
        this.addBubble('Something went wrong reaching Yves. Please try again in a moment.', 'yves');
        console.error(error);
      } finally {
        this.analyseBtn.disabled = false;
        if (!this.input.disabled) {
          this.sendBtn.disabled = false;
        }
      }
    }

    scrollToLatest() {
      window.requestAnimationFrame(() => {
        this.root.scrollIntoView({ block: 'end', behavior: 'smooth' });
      });
    }
  }

  document.querySelectorAll('[data-yves-coach]').forEach((root) => {
    if (!root.dataset.yvesInitialized) {
      root.dataset.yvesInitialized = 'true';
      new YvesCoach(root);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
